import { styled } from '@/stitches.config';

import { Box } from '@base-app';
import { ReactComponent as AtHome } from '@assets/icons/at-home.svg';
import { ReactComponent as InPerson } from '@assets/icons/in-person.svg';

export const StyledAwaitingSamplesContainer = styled(Box, {
  display: 'flex',
});

export const StyledAtHomeIcon = styled(AtHome, {});
export const StyledInPersonIcon = styled(InPerson, {});

export const StyledTitle = styled(Box, {
  fontWeight: '$bold',
  fontSize: '$sm',
  lineHeight: '$4',
  letterSpacing: '0.5px',
  color: '$darkGray300',
  textTransform: 'uppercase',
  textAlign: 'left',
});
